import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n.use(LanguageDetector).init({
    // we init with resources
    resources: {
        de: {
            translations: {
                welcome_name:  "Herzlich Willkommen, {{name}}",
                welcome_name_validation:  "Danke für Deine Bestätigung, {{name}}. Jetzt geht's los!",
                welcome_body: "Der Telekom-Techniker hat uns mitgeteilt, dass Ihre Anschaltung heute leider nicht geklappt hat. Das tut uns leid.",

                welcome_techniker_termin_title: "Teste Deine Router-Verbindung",
                welcome_techniker_termin_body1: "Probier bitte mal aus, ob das Internet an Deinem Router schon funktioniert. Wie das geht siehst Du ",
                welcome_techniker_termin_body1_link: "hier",
                welcome_techniker_termin_body2: "Wenn's funktioniert, hat der Techniker seine Arbeit direkt am Hauptverteiler erledigt und brauchte nicht in Deine Wohnung.",
                welcome_techniker_termin_body3: "Wenn's nicht funktioniert, gib uns hier bitte Bescheid. Dann siehst Du die nächsten Schritte.",

                question_1_OLD: "Hast Du probiert, ob Dein Anschluss schon funktioniert?",
                question_1: "Hast Du schon probiert ob Dein neuer Vodafone DSL-Anschluss funktioniert?",
                answer_1_1_OLD: "Ja, mein Anschluss läuft.",
                answer_1_1: "Ja, mein Internet funktioniert.",
                answer_1_2: "Nein, geht leider nicht.",
                answer_1_1_value: "answer_1_1_value",
                answer_1_2_value: "answer_1_2_value",

                installed_title: "Super! Danke für Deine Antwort.",
                installed_body_1: "Willkommen in unserem Highspeed-Netz und viel Spaß mit Deinem DSL-Anschluss! {{emoji_heart}}",
                installed_body_2: "Zur Sicherheit checken wir Deinen Anschluss. Dabei kann Dein Telefon kurz klingeln.",
                installed_body_3: "Falls was ist, rufen wir Dich auf Deinem Handy an. {{emoji_up}}",
				
				tam6000_entry_title: "Leider hat's nicht geklappt.",
				tam6000_entry_body_1: "Der Telekom-Techniker hat uns mitgeteilt, dass Du die Aktivierung  abgelehnt hast.",
				tam6000_entry_question: "Wir wollen Dich weiterhin mit unseren GigaNetz verbinden. Wie sieht's bei Dir aus?",
				tam6000_entry_answer_1: "Ja, los. Weiter geht's!",
				tam6000_entry_answer_2: "Nein, ich will den Anschluss nicht mehr.",				
				tam6000_cancelled_title: "Das ist schade.",
				tam6000_cancelled_body_1: "Schade, dass Du es Dir anders überlegt hast.",
				tam6000_cancelled_body_2: "Wir leiten Dich jetzt in unser Retourenportal weiter. Folge dort einfach den Anweisungen.",
				tam6000_cancelled_button: "Weiter zum Retourenportal",
				tam6000_entry_calendar_title: "Neuer Versuch",
				tam6000_entry_calendar_body_1: "Um Deinen Anschluss zu aktivieren, muss nochmal ein Techniker zu Dir kommen. Du kannst jetzt Vormittag oder Nachmittag wählen. So ist es einfacher für Dich.",
				tam6000_entry_calendar_body_2: "Du weißt schon, wann Du den Termin willst? Super, dann auf zum nächsten Schritt.",
				tam6000_entry_calendar_body_3: "Du weißt es noch nicht? Dann komm einfach später wieder.",
				tam6000_entry_calendar_button: "Termin aussuchen",
				tam6000_calendar_title: "Wann soll der Techniker kommen?",
				tam6000_calendar_confirm_title: "Passt alles für Dich?",
				tam6000_calendar_confirm_body: "Check nochmal den Tag und die Uhrzeit. Dann schick ab.",
				tam6000_calendar_confirm_button: "Terminwahl bestätigen",
				tam6000_waiting: "Warten auf Rückmeldung",
				tam6000_calendar_confirmed_title: "Vielen Dank für Deine Termin-Wahl",
				tam6000_calendar_confirmed_body: "Dein Termin haben wir gespeichert. Wenn sich was ändert, melden wir uns bei Dir.",
				
				tam6001_entry_title: "Techniker verpasst?",
				tam6001_entry_body_1: "Die Telekom hat uns mitgeteilt, dass der Techniker bei Dir war und niemand aufgemacht hat.",
				tam6001_entry_body_2: "Bitte such Dir einen neuen Termin aus. Du kannst jetzt zwischen Vormittag und Nachmittag wählen. {{emoji_date}}",
				tam6001_entry_body_3: "Am Ende fragen wir Dich noch, ob Du zuhause warst.",

				tam6001_entry_button: "Termin aussuchen",
				tam6001_calendar_confirm_title: "Stimmt das so?",
				tam6001_calendar_confirm_body: "Sag uns eins noch:",
				tam6001_calendar_confirm_body_2: "Warst Du zuhause?",
				tam6001_calendar_confirm_button: "Terminwahl bestätigen",
				
				tam6002_entry_title: "Zugang zum Hausverteiler",
				tam6002_entry_body_1: "Der Telekom-Techniker konnte Deinen Anschluss nicht einrichten. Er hatte keinen Zugang zu Deinem Hausverteiler (APL). Dort muss er das Kabel zu Deiner Wohnung mit dem Vodafone-Netz verbinden.",
				tam6002_entry_answer_1: "Ich weiß nicht, was der APL ist und wie ich den Zugang sicherstellen kann.",
				tam6002_entry_answer_2: "Stimmt, ich konnte den Zugang nicht sicherstellen.",
				tam6002_entry_calendar_title: "Neuer Versuch",
				tam6002_entry_calendar_body_1: "Nächstes Mal klappt alles. Ich brauch nur einen neuen Termin. {{emoji_up}}",
				tam6002_entry_button: "Termin aussuchen",

				tam6003_entry_title: "Alles richtig? ",
				tam6003_entry_body_1: "Der Telekom-Techniker hat Dich hier gesucht und leider nicht gefunden:",
                tam6003_address_correct: "Stimmt die Adresse?",
				tam6003_entry_button_address_yes: "Ja, stimmt.",
				tam6003_entry_button_address_no: "Nein, stimmt nicht.",
				tam6003_entry_calendar_title: "Neuer Versuch",
				tam6003_entry_calendar_body_1: "Gibt es für den Techniker etwas zu beachten, sodass er Dich in jedem Fall findet?",
				tam6003_entry_calendar_body_2: "Dein Hinweis an den Techniker:",
				tam6003_entry_calendar_button: "Termin auswählen",

				callback_title_6003: "Vereinbare einen Rückruf.",
				callback_body_6003: "Du willst Deine Adresse korrigieren. Kein Problem. Wir prüfen mit Dir am Telefon, ob sich dadurch an Deinem Tarif was ändert. {{emoji_think}}",
				callback_body_2_6003: "Gib hier Deine Nummer ohne Leer- oder Sonderzeichen ein, zum Beispiel: 01721234566. Wir melden uns in wenigen Minuten bei Dir. {{emoji_up}}",
				callback_button_6003: "Abschicken",
				
				callback_title_60xx: "Hat nicht geklappt",
				callback_body_1_60xx: "Die Telekom hat uns Bescheid gegeben, dass es heute nicht geklappt hat. ",
				callback_body_2_60xx: "Wir wollen Dir so schnell wie möglich helfen. Lass uns telefonieren. Dann bekommst Du eine Übergangslösung und wir besprechen die nächsten Schritte.",
				callback_body_3_60xx: "Gib hier Deine Nummer ohne Leer- oder Sonderzeichen ein, zum Beispiel: 01721234566. Wir melden uns in wenigen Minuten bei Dir. {{emoji_up}}",
				callback_button_60xx: "Abschicken",
				
				tam6003_calendar_confirm_title: "Damit der Techniker Dich findet",
				tam6003_calendar_confirm_body: "Dass alles klappt, ist uns sehr wichtig. Hier hast Du ein Klingelschild. So findet Dich der Techniker garantiert {{emoji_wink}}",
				tam6003_calendar_confirm_klingeschild_button: "Klingelschild drucken",
				tam6003_calendar_confirm_button: "Abschicken",
				
				tam6006_entry_title: "Da hat was nicht geklappt",
				tam6006_entry_body_1: "Manchmal steckt der Teufel im Detail.",
				tam6006_entry_body_2: "Was schiefgelaufen ist und wie es weitergeht, klären wir jetzt mit der Telekom. Wir geben Vollgas. In spätestens 24 Stunden rufen wir Dich auf Deinem Handy an. {{emoji_detective}}",				 

				send: "Abschicken",
				

                answer_1_1_after_appointment_select: "Ja, ich war zuhause.",
                answer_1_2_after_appointment_select: "Nein, ich hab´s leider verpasst.",
                answer_1_1_value_after_appointment_select: "answer_1_1_value_after_appointment_select",
                answer_1_2_value_after_appointment_select: "answer_1_2_value_after_appointment_select",

                zusammenfassung_title: "Zusammenfassung",
                zusammenfassung_body_after_appointment_select: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.",
                zusammenfassung_warning_after_appointment_select_yes: "Ich bestätige, dass ich oder eine von mir autorisierte Person im angekündigten Zeitraum vor Ort auf den Techniker gewartet hat und er nicht erschienen ist.",
                zusammenfassung_warning_after_appointment_select_no: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.",

                zusammenfassung_klingel_title: "Zusammenfassung und Klingelschildvorlage",
                zusammenfassung_klingel_body: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.",
                download_vorlage_klingel: "Vorlage herunterladen",
                zusammenfassung_klingel_appointment_confirm: "Terminwahl bestätigen",

                apl_title: "Warum der Techniker Zugang zum APL braucht.",
                apl_body_1: "Der Telekom-Techniker verbindet Deinen Hausanschluss mit dem Vodafone-Netz. Dazu braucht er Zugang zum Hausverteiler, dem APL.",
				apl_body_2: "Der ist meist im Keller, kann aber auch außen an der Hauswand sein.",
				apl_2_title: "Was ist der APL",
				apl_2_body: "Der Anschlusspunkt Linientechnik (APL) ist der Eingang des Kabels von der Straße ins Haus. Meistens im Keller oder im Haustechnikraum. Hier siehst Du ein paar Varianten.",
				apl_3_title: "Wie komm ich dran?",
				apl_3_body_1: "Ist der APL in einem verschlossenen Raum oder Du findest ihn nicht?",
				apl_3_body_2: "Dann sprich mit Deinem Vermieter, Hausmeister oder der Hausverwaltung. Sie haben den Schlüssel. {{emoji_key}}",

				tam6002_apl04_entry_calendar_title: "Neuer Versuch",
				tam6002_apl04_entry_calendar_body_1: "Ich weiß jetzt, wo der APL ist und wie ich drankomme. Jetzt brauch ich nur noch einen neuen Termin.",
				tam6002_apl04_entry_button: "Termin auswählen",

                address_confirm_title: "Lieber Vodafone-Kunde,",
                address_confirm_body: "Der Telekom-Techniker hat uns mitgeteilt, dass er Sie an Ihrer angegebenen Adresse nicht vorfinden konnte. Bitte prüfen Sie, ob die nachfolgende Adresse korrekt ist:",

                select_appointment_label: "Dein Termin:",

                select_appointment: "Termin auswählen",
                select_technician_appointment: "Techniker-Termin auswählen",
                select_technician_appointment_confirm: "Techniker-Termin bestätigen",
                select_technician_appointment_back: "Zurück",
                select_my_address: "Ja, Adresse ist korrekt",
                select_new_address: "Nein, Adresse ist nicht korrekt",

                callback_confirmed_title: "Danke! Wir melden uns gleich bei Dir.",
                callback_confirmed_body: "Du bekommst jetzt eine SMS von uns. Dort steht, wann wir Dich anrufen.",
				callback_confirmed_body_2: "Kein Warten! Wir melden uns in wenigen Minuten.",
                your_phone_label: "Deine Rufnummer:",

                callback_confirmed_title_60xx: "Rückruf vereinbart",
                callback_confirmed_body_60xx: "Du bekommst gleich eine SMS mit der Rückrufzeit. ✔",

                server_error_title: "Es gibt ein technisches Problem",
                server_error_body: "Wir können aktuell keine Verbindung zu unserem System herstellen. Bitte probier es in fünf Minuten nochmal.",


                technician_appointment: "Techniker-Termin",
                technician_description: "Ein Techniker der Telekom schaltet den Anschluss in deinem Haus frei. Stell bitte sicher, dass Du oder jemand anderes zuhause ist.",
                technician_description_2: "Wir bieten Dir hier immer die frühesten Termine, die wir haben. Wir können Dir also auch am Telefon keinen früheren Termin geben.",
                technician_setup_text: "Vereinbar einen Techniker-Termin, empfang Deinen Router und behalt dabei stets die Übersicht.",

                receive_router: "Router bekommen",
                receive_clearing: "Freigeschaltet werden",
                lets_go: "Los geht's",

                select_technician_appointment_title: "Wann soll der Techniker kommen?",
                select_technician_appointment_body: "Stelle bitte sicher, dass Du oder jemand anderes zuhause ist. Und dass der Techniker in Deinen Keller kann.",
                select_technician_appointment_body_pt2: "Wir bieten Dir die frühesten Termine, die wir haben. Auch per Telefon können wir Dir keine früheren anbieten.",
                time_window_and_duration: "Zeitfenster & Dauer",
                prepare: "Vorbereiten",
                readable_doorbell_and_basement_sign: "Name an der Tür & Kellerschlüssel",
                x_o_clock_approx_x_minutes: "{{time}} Uhr ca. {{duration}}min",
                select_day_title: "Welcher Tag passt Dir?",
                weekday_date: "{{weekday}}, {{date}}",
                select_day_body: "An Wochenenden und Feiertagen klappt das leider nicht. Du kannst Deinen Termin noch bis zu 3 Tage vorher ändern.",
                continue: "Weiter",
				ok: "Ok",
                previous_tenant_title: "Wie heißt Dein Vormieter?",
                previous_tenant_body: "Mit der Info kann Dein Anschluss vielleicht sogar ohne Techniker-Termin freigeschaltet werden. Dann musst du nicht zuhause sein.",
                skip: "Überspringen",
                first_name: "Vorname",
                last_name: "Nachname",
                check_your_information_title: "Stimmt alles?",
                previous_tenant_name: "Name Deines Vormieters",
                address_of_line: "Deine Anschluss-Adresse *",
                street: "Straße",
                street_number: "Hausnummer",
                post_code: "PLZ",
                city: "Stadt",
                contact_information: "Deine Kontaktinfos *",
                contact_number: "Deine Rufnummer",
                contact_email: "Deine Email-Adresse",
                building_details: "Details zu Deinem Haus *",
                building: "Wohngebäude",
                floor: "Etage",
                side: "Seite",
                left: "links",
                middle: "mitte",
                right: "rechts",
                basement:"Keller",
                souterrain:"Souterrain",
                ground_floor:"Erdgeschoss",
                level_x: "{{count}}. Etage",
                apartment_building:"Mehrfamilienhaus",
                detached_house:"Einfamilienhaus",
                submit: "Abschicken",
                confirm_thanks: "Bestätigt!",

                checking_appointment_title: "Vielen Dank! Wir prüfen Deinen Termin.",
                checking_appointment_change_notice_mobile: "Du kannst Deinen Termin noch bis 3 Tage vorher ändern. Und auf dieser Seite hier jederzeit den Status prüfen.",
                checking_appointment_change_notice_desktop_1: "Du kannst Deinen Termin noch bis 3 Tage vorher ändern.",
                checking_appointment_change_notice_desktop_2: "Und auf dieser Seite hier jederzeit den Status prüfen.",

                stage_5_save_page_mobile: "Speicher die Seite als Favorit. Dann kannst Du den Status Deines DSL-Auftrags einfacher und schneller abrufen:",
                stage_5_save_page_desktop: "Speicher die Seite als Favorit. Dann kannst Du den Status Deines DSL-Auftrags einfacher und schneller abrufen:",
                stage_5_appointment_description_desktop_1: "Der Techniker kommt zwischen 8 und 13 Uhr oder zwischen 13 und 17 Uhr.",
                stage_5_appointment_description_desktop_2: "Wie lange der Termin wahrscheinlich dauert, schreiben wir in der Termin-Bestätigung.",
                stage_5_appointment_pending_mobile: "Termin wird geprüft",
                stage_5_appointment_pending_desktop: "Termin wird überprüft",

                vodafone_hilfe_title_desktop:"Hast Du mal Probleme mit dem Internet, helfen wir Dir gerne weiter:",
                netzassistent_title_desktop:"Hast Du mal Probleme mit dem Internet, hilft Dir der Netz-Assistent für Dein Smartphone:",
                launch_vodafone_hilfe:"Vodafone Hilfe öffnen",
                launch_netzassistant:"Netz-Assistent öffnen",

                checking_appointment_body: "Der Termin ist bis zu 3 Tage vorher änderbar. Du kannst diese Seite jederzet öffnen, um Dich über den Fortschritt zu informieren!",
                save_this_page: "Speicher die Seite als Favorit. Dann kannst Du den Status Deines DSL-Auftrags einfacher und schneller abrufen.",
                add_bookmark: "Lesezeichen hinzufügen",
                add_to_homescreen: "Auf Homescreen speichern",
                copy_link: "Link kopieren",
                waiting_for_availability: "Warte auf Verfügbarkeit",
                appointment_available: "Dein Wunsch-Termin ist frei! Bestätige ihn jetzt.",
                please_make_sure: "Stell bitte 3 Dinge sicher, damit der Techniker Dein Internet freischalten kann:",
                name_on_door: "Dein Name steht gut lesbar an der Klingel.",
                access_to_basement: "Der Techniker kann den Keller betreten.",
                phone_ready: "Du hast ein Handy zur Hand.",
                first_appointment_free: "Dein 1. Techniker-Termin ist kostenlos für Dich. Bist Du nicht zuhause, berechnen wir Dir 59 Euro für einen neuen Termin.",
                time_o_clock: "{{time}} Uhr",
                change_appointment: "Termin ändern",
                confirm: "Bestätigen",

                countdown_more_than_2_weeks_to_go: "In wenigen Wochen ist es soweit",
                countdown_2_weeks_to_go: "Keine 2 Wochen mehr",
                countdown_soon: "Bald ist es soweit",
                countdown_are_you_ready: "Are you ready?",
                countdown_3_days: "Noch 3-mal schlafen",
                countdown_2_days: "Noch 48 Stunden",
                countdown_1_days: "Morgen geht's los",

                in_a_few_weeks_the_technician_will_come: "In wenigen Wochen ist es soweit",
                x_weeks_to_go_plural: "Nur noch {{count}} Wochen",
                x_weeks_to_go: "Nur noch eine Woche!",
                almost_there: "Bald ist es so weit!",
                sleep_x_times_plural: "Nur {{count}}-Mal schlafen!",
                sleep_x_times: "Morgen ist es soweit!",
                x_days_to_go_plural: "Noch {{count}} Tage",
                x_days_to_go: "Noch ein Tag",
                appointment_today: "Heute ist es soweit",

                appointment_passed_title: "Hat alles geklappt?",

                router_will_be_shipped: "Kurz vor dem Techniker-Termin versenden wir Deinen Router. Die Tracking-Nummer und das Zustelldatum findest Du natürlich hier.",
                appointment_can_be_changed: "Der Termin ist bis zu 3 Tage vorher änderbar. Erstell einen Kalendereintrag, um vor Ablauf der Frist noch einmal erinnert zu werden.",
                appointment_can_not_be_changed: "Deinen Techniker-Termin kannst Du jetzt leider nicht mehr ändern. Die Deutsche Telekom braucht 4 Tage Vorlaufzeit, um die Einsatzzeiten der Techniker zu planen. Einen neuen Termin kannst Du erst vereinbaren, nachdem Dein geplanter Termin verstrichen ist.",
                save_reminder: "Erinnerung im Kalender speichern",
                save_reminder_to_calendar: "Termin im Kalender speichern",
                technician_appointment_x: "Techniker-Termin: {{date}}, {{time}} Uhr",
                change: "Ändern",
                router_delivery_description_mobile: "Ein paar Tage vor dem Techniker-Termin schicken wir Dir Deinen Router. Du siehst hier dann die Tracking-Nummer und das Zustelldatum.",
                router_delivery_description_mobile_mytechie: "Um Deine DSL-Anschaltung kümmert sich morgen ein Techniker der Deutschen Telekom. Weitere Infos über einen genaueren Zeitpunkt bekommst Du über den Link, den wir Dir heute per SMS zuschicken.",
                router_delivery_description_desktop_1: "Ein paar Tage vor dem Techniker-Termin schicken wir Dir Deinen Router.",
                router_delivery_description_desktop_2: "Du siehst hier dann die Tracking-Nummer und das Zustelldatum.",

                technician_will_come: "Der Techniker kommt zum vereinbarten Termin und schaltet das Internet für Dich frei.",
                router_was_shipped_title: "Dein Router ist unterwegs.",
                router_was_delivered: "Dein Router wurde zugestellt.",
                router_was_shipped_body: "Der Router sollte wenige Tage vor deinem Techniker-Termin bei Dir ankommen",
                router_was_shipped_body_mytechie: "Um Deine DSL-Anschaltung kümmert sich morgen ein Techniker der Deutschen Telekom. Weitere Infos über einen genaueren Zeitpunkt bekommst Du über den Link, den wir Dir heute per SMS zuschicken.",
                router_will_arrive_in_x_days_plural: "Dein Router kommt in {{count}} Tagen.",
                router_will_arrive_in_x_days: "Dein Router ist morgen bei Dir.",
                router_will_arrive_today: "Dein Router kommt heute",
                package_tracking: "Paket-Tracking",
                almost_there_title: "Bald ist es soweit! Stell sicher, dass Du da bist.",
                almost_there_body: "Heute ist die letzte Chance, den Termin zu ändern. Bitte denk daran, dass Kosten entstehen, wenn der Techniker Dich nicht erreicht.",
                x_more_nights_title: "Noch {{days}}-Mal schlafen.",
                x_more_nights_body: "Der Router funktioniert erst nach dem Techniker Termin. Weißt du schon, wo Du ihn hinstellen wirst?",
                cannot_be_changed: "Nicht mehr änderbar",

                has_everything_worked_out_title: "Heute ist es soweit - hat alles geklappt?",
                has_everything_worked_out_body: "Wenn der Techniker schon bei Dir war, kannst Du Deinen Router jetzt anschließen und einrichten.",
                has_everything_worked_out_body_mytechie: "Endlich ist es so weit: Der Techniker der Deutschen Telekom schaltet heute im festgelegten Zeitraum Deinen DSL-Anschluss an. Weitere Infos über einen genaueren Zeitpunkt bekommst Du über den Link, den wir Dir per SMS zugeschickt haben. Wenn der Techniker bei Dir war, funktioniert das Internet jetzt.",
                has_everything_worked_out_note: "Der Techniker war noch nicht da? Er kommt bestimmt bald. Der vorgesehene Zeitraum ist {{time}} Uhr. Wir können Dir auch am Telefon nicht sagen, wann genau er kommt.",

                is_it_done_title: "Heute ist es soweit - ist es geschafft?",
                is_it_done_body: "Wenn der Techniker bei Dir war, funktioniert das Internet jetzt. Zeit, den Router einzurichten!",
                is_it_done_body_mytechie: "Endlich ist es so weit: Der Techniker der Deutschen Telekom schaltet heute im festgelegten Zeitraum Deinen DSL-Anschluss an. Weitere Infos über einen genaueren Zeitpunkt bekommst Du über den Link, den wir Dir per SMS zugeschickt haben. Wenn der Techniker bei Dir war, funktioniert das Internet jetzt.",

                router_setup_time: "Zeit, den Router einzurichten!",
                set_up_router: "Jetzt Router einrichten",
                there_was_a_problem: "Es gab ein Problem.",
                technician_late: "Der Techniker war immernoch nicht da? Das tut uns Leid! Manchmal sorgen lange Termine und viel Verkehr für Verspätungen. Geb ihm noch bis {{time}} Uhr Zeit, er ist bestimmt schon auf dem Weg zu dir.",
                router_setup_title: "Richte Deinen Router ein",
                router_setup_title_desktop: "Fehlt nur noch die Router-Installation",
                router_setup_body_mobile: "Das geht einfach und schnell. Du brauchst nur den Router und Deinen Modem-Installations- Code. Den hast Du von uns per E-Mail oder Brief bekommen.",
                router_setup_body_desktop: "Das geht einfach und schnell. Du brauchst nur den Router und Deinen Modem-Installations-Code.",
                router_setup_subtext_desktop: "Den Modem-Installations- Code hast Du von uns per E-Mail oder Brief bekommen.",
                router_setup_instructions: "So richtest Du Deinen Router ein:",
                step_by_step_guide: "Schritt-für Schritt-Guide",
                i_am_online: "Ich bin Online!",
                welcome_to_the_high_speed_network_title: "Willkommen in unserem Highspeed-Netz!",
                myvodafone: "MeinVodafone",
                myvodafone_description: "Du findest Deine Rechnungen, Vertragsdaten und vieles mehr in Deinem Service-Portal.",
                login: "Login",
                was_there_an_issue: "Gab es ein Problem mit Deinem Internet?",
                invalid_post_code: "Die PLZ ist leider ungültig",
                invalid_phone_number: "Die Telefonnummer ist ungültig",
                invalid_email: "Die Email-Adresse ist ungültig",
                plz_city_mismatch: "Die PLZ und Stadt passen nicht zusammen",
                no_technician_required_title: "Kein Techniker-Termin notwendig",
                no_technician_required_body: "Kurz vor der Freischaltung versenden wir Deinen Router. Die Tracking-Nummer und den Zustell-Termin findest du natürlich hier.",
                line_available_on: "Freischaltung: {{date}}, {{time}} Uhr",
                line_availability: "Freischaltung",
                no_technician_required_info: "Du wirst ohne Techniker-Termin freigeschaltet.",
                no_technician_required_delay: "Immernoch kein Internet? Es wird bestimmt bald freigeschaltet. Der vorgesehene Zeitraum ist {{time}} Uhr. Innerhalb dieser Zeit können wir Dir auch telefonisch keine Auskunft über den Status der Freischaltung geben.",

                callback_title: "Vereinbare einen Rückruf.",
                callback_title_desktop: "Sollen wir Dich zurückrufen?",
                callback_body_1: "Da muss etwas schief gelaufen sein. Bitte vereinbare einen Rückruftermin.",
                callback_body_1_desktop: "Da hat wohl etwas nicht geklappt. Lass uns telefonieren.",
                callback_body_2: "Ein Service-Kollege ruft Dich dann zurück, sobald du bereit bist.",
                callback_body_2_desktop: "Ein Service-Kollege ruft Dich zurück. Gib bitte Deine Rufnummer ein und klick unten den Button.",

                callback_confirm_title: "Vielen Dank, wir rufen Dich zurück.",
                callback_confirm_body: "Du bekommst gleich eine SMS mit der Rückrufzeit.",
                callback_confirm_button: "Schließen",
                callback_confirm_note: "Rückruf vereinbart! Ein Service-Kollege meldet sich bald bei Dir.",
                success_icon: "Erfolgreich.",

                request: "Anfordern",
                request_desktop: "Ruft mich bitte zurück",
                callback_note: "Rückruf vereinbart! Ein Service-Kollege meldet sich in Kürze bei Dir.",
                no_appoinmtents_on_weekends_or_holidays: "Sa. So. & an Feiertagen können wir leider keine Termine anbieten",

                validation_title: "Herzlich willkommen bei Vodafone.",
                validation_body_1: "Bevor es los geht, möchten wir sicher sein, dass Du's bist.",
                validation_body_2: "Zu Deinem DSL-Vertrag haben wir diese Daten. Sind das Deine Daten?",
                validation_label_phone: "Mobilfunk-Rufnummer",
                validation_label_name: "Dein Name",
                validation_button_valid_text: "Ja, ich bestätige meine Daten*",
                validation_button_invalid_text: "Nein, das sind nicht meine Daten. Bitte löschen.",
                validation_fine_print: "*Wichtig: Wenn Du hier eine falsche Angabe machst, kann das strafrechtliche Konsequenzen haben.",

                invalid_title: "Danke für Deine Rückmeldung!",
                invalid_body_1: "Wir löschen die Daten so schnell wie möglich.",
                invalid_body_2: "Weitere Infos zu Deiner DSL-Anschaltung bekommst Du per Post oder per E-Mail.",
                invalid_body_3: "Freundliche Grüße,",
                invalid_body_4: "Ihr Vodafone-Team.",

                monday: "Montag",
                tuesday: "Dienstag",
                wednesday: "Mittwoch",
                thursday: "Donnerstag",
                friday: "Friday",
                saturday: "Samstag",
                sunday: "Sonntag",

                mon: "Mo",
                tue: "Di",
                wed: "Mi",
                thu: "Do",
                fri: "Fr",
                sat: "Sa",
                sun: "So",

                january: "Januar",
                february: "Februar",
                march: "März",
                april: "April",
                may: "Mai",
                june: "Juni",
                july: "Juli",
                august: "August",
                september: "September",
                october: "Oktober",
                november: "November",
                december: "Dezember",

                error_missing_phone_number: "Bitte trag deine Rufnummer ein",
                internet_problems_title: "Gibt es ein Problem mit Deinem Internet?",
                internet_problems_body: "Dann hilft Dir jederzeit Dein persönlicher Netz-Assistent:",
                footer_link: "Rechtliches",
                footer_button_conditions: "AGB",
                footer_button_imprint: "Impressum",
                footer_button_privacy: "Datenschutz",
                footer_title: "Rechtliches",

                homescreenButton_title: "Tipp: Speicher diese Seite.",
                homescreenButton_bodytext: "So bleibst Du immer auf dem neuesten Stand zum Router-Versand und Deinem Techniker-Termin.",
                homescreen_button_bookmark: "Lesezeichen hinzufügen",
                homescreen_button_homescreen: "Auf Homescreen speichern",
                homescreen_button_copy: "Link kopieren"


            }
        }
    },
    fallbackLng: "de",
    debug: false,

    // have a common namespace used around the full app
    ns: ["translations"],
    defaultNS: "translations",

    keySeparator: false, // we use content as keys

    interpolation: {
        escapeValue: false, // not needed for react!!
        formatSeparator: ","
    },

    react: {
        wait: true
    }
});

export default i18n;
